export default __webpack_public_path__ + "static/media/why-we-started-lovrican-mobile.ec020348.webp";